import React, { useEffect, useState } from "react";
import { Modal, LegacyStack, Text, Box } from "@shopify/polaris";
import horseLogo from "images/horse-logo-110.png";
import moreMoneyIcon from "images/more-money-icon.png";
import { getReadBanner, createReadBanner } from "../../../api_utils/requests";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_BANNER_KEY } from "../../../constants";

const steps = {
  1: {
    header: "Welcome to Horse!",
    body: "Horse gives you magical inventory powers so that you can focus on running your business.",
    logo: horseLogo,
  },
  2: {
    header: "No setup required",
    body: "As soon as Horse finishes importing your store's data, you'll be ready to start earning more money!",
    logo: moreMoneyIcon,
  },
};

function Onboarding(): React.ReactElement {
  const [alreadySeen, setAlreadySeen] = useState(true);
  useEffect(() => {
    void getReadBanner(ONBOARDING_BANNER_KEY).catch((e: unknown) => {
      if (e instanceof Error && e.message.includes("404")) {
        setAlreadySeen(false);
      }
    });
  }, []);

  const dismissBanner = async (): Promise<void> => {
    setAlreadySeen(true);
    await createReadBanner(ONBOARDING_BANNER_KEY);
  };

  const navigate = useNavigate();

  const [onboardingStep, setOnboardingStep] = useState(1);
  let actions;
  if (onboardingStep === Object.keys(steps).length) {
    actions = {
      primaryAction: {
        content: "Sales trends",
        onAction: () => {
          void dismissBanner();
          setTimeout(() => {
            navigate("/sales_trends");
          });
        },
      },
      secondaryActions: {
        content: "Make a purchase order",
        onAction: () => {
          void dismissBanner();
          setTimeout(() => {
            navigate("/purchase_orders/new");
          });
        },
      },
    };
  } else {
    actions = {
      secondaryActions: {
        content: "Next",
        onAction: () => {
          setOnboardingStep(onboardingStep + 1);
        },
      },
    };
  }

  return (
    <Modal onClose={dismissBanner} open={!alreadySeen} small titleHidden {...{ ...actions }}>
      <Modal.Section>
        <Box padding="400">
          <LegacyStack distribution="center">
            <img height={110} src={steps[onboardingStep].logo} style={{ margin: "1em" }} />
          </LegacyStack>
          <LegacyStack distribution="center">
            <Text as="h2" variant="headingMd">
              {steps[onboardingStep].header}
            </Text>
          </LegacyStack>
          <LegacyStack distribution="center">
            <p className="text-center">{steps[onboardingStep].body}</p>
          </LegacyStack>
        </Box>
      </Modal.Section>
    </Modal>
  );
}

export default Onboarding;
